import React from 'react'
import { Icon, Modal, Row, Tabs } from 'antd'
import CenterForm from './CenterForm'
import History from '../../../components/Common/History'
import Documents from '../../../components/Common/Documents/DocumentsCont'
import BudgetCont from '../../../components/Common/Budgets/BudgetCont'

const { TabPane } = Tabs

function CenterModal(props) {
  const { visible, center, isNew, onCancel, update, formRef, submitting } = props
  return (
    <Modal
      key={center._key}
      destoryOnCancel={true}
      title={'Update Center'}
      visible={visible}
      onCancel={onCancel}
      okText={'Update'}
      onOk={update}
      width={'75%'}
      confirmLoading={submitting}>
      <Row>
        <Tabs defaultActiveKey="details">
          <TabPane tab="Details" key="details">
            <CenterForm ref={formRef} {...props} />
          </TabPane>
          <TabPane
            disabled={true}
            tab={
              <span>
                <Icon type="credit-card" />
                Budget
              </span>
            }
            key="#budgets">
            <BudgetCont owner={center} />
          </TabPane>
          <TabPane disabled={true} tab="Files" key="files">
            <Documents editable={true} footer={false} category={false} owner={center} />
          </TabPane>
          <TabPane tab={'History'} key="#history">
            <History owner={center} />
          </TabPane>
        </Tabs>
      </Row>
    </Modal>
  )
}

CenterModal.propTypes = {}
CenterModal.defaultProps = {}

export default CenterModal
